export default "__VITE_ASSET__DBhIwSRV__"